import { Typography } from '@mui/material'

type Props = {
  children?: string
  noMargin?: boolean
}

export const ErrorMessage = ({ children, noMargin }: Props) => {
  if (!children) return null

  return (
    <Typography
      aria-label={children}
      color="error"
      fontWeight="bold"
      role="alert"
      sx={{ mt: noMargin ? 0 : 1 }}
      variant="body2"
    >
      {children}
    </Typography>
  )
}
